import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navClasses = `fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
    isScrolled || !isHome
      ? 'bg-white shadow-sm'
      : 'bg-white/10 backdrop-blur-sm'
  }`;

  const textClasses = isScrolled || !isHome ? 'text-gray-900' : 'text-white';
  const logoClasses = isScrolled || !isHome ? 'brightness-0' : 'brightness-0 invert';

  return (
    <nav className={navClasses}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/adbcdcc03ccb95572cdcd393dd2136c2/631bd77c1f2ded16e08e1107118d31d0.png"
              alt="Bravia Group"
              className={`h-10 transition-all duration-300 ${logoClasses}`}
            />
          </Link>

          <div className="hidden md:flex items-center space-x-10">
            <Link
              to="/sobre"
              className={`${textClasses} hover:opacity-70 transition-opacity font-medium text-sm tracking-wide whitespace-nowrap`}
            >
              Sobre
            </Link>
            <Link
              to="/investir"
              className={`${textClasses} hover:opacity-70 transition-opacity font-medium text-sm tracking-wide whitespace-nowrap`}
            >
              Investir
            </Link>
            <Link
              to="/projetos"
              className={`${textClasses} hover:opacity-70 transition-opacity font-medium text-sm tracking-wide whitespace-nowrap`}
            >
              Projetos
            </Link>
            <Link
              to="/conteudo"
              className={`${textClasses} hover:opacity-70 transition-opacity font-medium text-sm tracking-wide whitespace-nowrap`}
            >
              Conteúdo
            </Link>
            <Link
              to="/contato"
              className={`${textClasses} hover:opacity-70 transition-opacity font-medium text-sm tracking-wide whitespace-nowrap`}
            >
              Contato
            </Link>
          </div>

          <a
            href="https://wa.me/16892960820"
            target="_blank"
            rel="noopener noreferrer"
            className={`hidden md:block px-6 py-3 rounded-full font-medium text-sm transition-all whitespace-nowrap cursor-pointer ${
              isScrolled || !isHome
                ? 'bg-gray-900 text-white hover:bg-gray-800'
                : 'bg-white text-gray-900 hover:bg-gray-100'
            }`}
          >
            Falar com especialista
          </a>
        </div>
      </div>
    </nav>
  );
}
